<template>
  <div class="pub-header">
    <div class="header">
      <div class="header-top">
        <ul class="top-info">
          <p class="tit-tip">中国区官网</p>
          <li>
            <a href="https://brest-bs.com/">法国官网</a>
          </li>
          <li>
            <a href="https://www.hainayx.com/">海纳易学</a>
          </li>
        </ul>
      </div>
    </div>
    <div style="clear:both"></div>
    <div class="header-daohang">
      <div class="navigation">
        <div class="logo" @click="toLinkHome">
          <img src="../assets/images/index-logo.png" alt=""/>
        </div>
        <div class="kind" @click="showCont">
          <img src="../assets/images/ai-kind.png"/>
        </div>
      </div>
      <div v-show="isShow" class="daohang-right">
        <com-meum></com-meum>
      </div>

    </div>
    <div class="toTop">
      <img v-if="btnFlag" class="go-top" src="../assets/images/zhiding.png" @click="backTop"/>
    </div>
  </div>
</template>
<script>
import ComMeum from "../components/comMeum.vue";

export default {
  // name:''
  components: {ComMeum},
  data() {
    return {
      isShow: false,
      btnFlag: false,
      eduShow: false,
      erjiShow: false,
    };
  },
  methods: {
    showCont() {
      this.isShow = !this.isShow;
    },
    /** 跳转首页*/
    toLinkHome() {
      this.$router.push({path: "/"});
    },
    // show() {
    //   // this.erjiShow = !this.erjiShow;
    //   this.eduShow = !this.eduShow;
    // },
    // showEdu() {
    //   // this.eduShow = !this.eduShow;
    //   this.erjiShow = !this.erjiShow;
    // },
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    //   // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  },

  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>
<style scoped>
.pub-header {
  width: 100%;
  height: 145px;
}

.header {
  width: 100%;
  height: 53px;
  line-height: 53px;
  background: rgba(229, 129, 17, 1);
}

.tel:before {
  content: "";
  background: url("../assets/images/dianhua.png") no-repeat;
  display: inline-block;
  width: 20px;
  height: 20px;
  background-size: 20px 20px;
  vertical-align: middle;
  margin-right: 10px;
}

.tel {
  font-size: 26px;
  color: #fff;
}

.header-top {
  width: 95%;
  margin: 0 auto;
}

.top-info {

}

.tit-tip {
  font-size: 26px;
  color: #fff;
  float: left;
}

.top-info li {
  float: right;
  margin-left: 28px;
}

.top-info li a {
  font-size: 26px;
  color: #fff;
}

.t1 {
  margin-top: -10px !important;
}

.header-daohang {
  width: 100%;
  height: 92px;
  line-height: 92px;
  background-color: #fff;
}

.navigation {
  width: 95%;
  margin: 0 auto;
  height: 92px;
  line-height: 92px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  width: 240px;
  height: 66px;
  padding-top: 12px;
}

.logo img {
  width: 100%;
}

.kind {
  width: 50px;
  height: 39px;
}

.kind img {
  width: 50px;
  height: 39px;
}

.daohang-right {
  width: 100%;
  background-color: #000;
  opacity: 0.9;
  position: absolute;
  top: 145px;
  right: 0px;
  z-index: 9999;
}

.daohang-item {
  height: auto;
  padding-bottom: 20px;
  /*min-width: 750px;*/
  width: 1200px;
}

.daohang-item li {
  width: 90%;
  margin: 0 auto;
  height: 80px;
}

.daohang-item li a {
  font-size: 32px;
  color: #fff;
  display: inline-block;
  width: 100%;
}

.edu-item {
  width: 90%;
  margin: 0 auto;
  font-size: 32px;
  color: #fff;
}

.eduShow {
  width: 90%;
  border-top: 1px solid #fff;
  margin: 0 auto;
}

.eduShow ul li {
  margin-left: 10%;
}

.erji {
  width: 90%;
  display: block;
  border-top: 1px solid #fff;
  margin: 0 auto;
}

.erji ul li {
  margin-left: 15%;
}

.erji-text {
  font-size: 32px;
  color: #fff;
}

.toTop {
  position: fixed;
  right: 0.2rem;
  bottom: 2rem;
  z-index: 99999;
}

.go-top {
  width: 1.2rem;
  height: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homeHeader.vue